export const navigation = (() => {
  const mainNavButtons = document.querySelectorAll(".sideMenu-button");
  Array.from(mainNavButtons).forEach((toggleBtn) => addEL(toggleBtn));

  const links = document.querySelectorAll(".sideMenu--guide .sideMenu-button");

  Array.from(links).forEach((link) => {
    link.addEventListener("click", function (e) {
      let hasChilds = e.currentTarget.classList.contains("sideMenu-button--has-children");
      let isLevel1 = e.currentTarget.classList.contains("level-1");
      if (hasChilds && isLevel1) {
        e.preventDefault();
      } else {
        const hasAccess = document
          .querySelector(".sideMenu--guide")
          .getAttribute("data-restrict").length > 0;
        if (!hasAccess && document.querySelector("#members-only")) {
          const dataId = e.currentTarget.getAttribute("data-id");
          const pathname = window.location.pathname.replace(/\/$/, "") + "/pagepreview?pageid=" + dataId;
          e.preventDefault();

          fetch(pathname)
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.json();
            })
            .then((data) => {
              document.querySelector(
                ".subpagehero-content .content-heading"
              ).innerHTML = data.header;
              document.querySelector(
                ".subpagehero-content .content-preamble"
              ).innerHTML = data.preamble;
              document
                .querySelector(".subpagehero-content .content-preamble")
                .classList.add("gradient-cover-text");
              document.querySelector(".subpagehero-content .content-editorial").innerHTML = "";
              document.querySelector("#content-item").innerHTML = "";
              document.querySelector("#block-full").innerHTML = "";
              document.querySelector("#members-only").classList.remove("hidden");
              const mobBtn = document.querySelector(".mobile-header--open") 
                if (mobBtn != null) {
                    mobBtn.click();
                }
               window.scrollTo({ top: 0, behavior: "smooth" });
            })
            .catch((error) => {
              console.error("Fetch error:", error); // Handle errors
            });
        }
      }
    });
  });

  function addEL(toggleBtn) {
    toggleBtn.addEventListener("click", function (e) {
      Array.from(mainNavButtons).forEach((b) => {
        if (e.target.classList.contains("sideMenu-button--action")) {
          e.preventDefault();
        }

        if (b === this) {
          const btn = this.querySelector(".sideMenu-button--action");
          if (btn == null) return;

          if (btn.getAttribute("aria-expanded") === "true") {
            this.classList.add("open");
          } else {
            this.classList.remove("open");
          }
          return;
        }

        let theId = b.getAttribute("aria-controls");
        b.setAttribute("aria-expanded", "false");

        let target = document.getElementById(theId);
        if (!target) return;

        target.setAttribute("aria-hidden", "true");
        target.classList.add("hidden");
      });

      // Update the parent's min-height based on the sideMenu's height plus an offset
      updateMainHeight();
    });
  }

  function updateMainHeight() {

    const main = document.querySelector(".main > .container");
    const sideMenu = document.querySelector(".sideMenu");

    // Handle EmployersGuide pages with absolutely positioned sidebar
    const employersGuideMain = document.querySelector('.employersGuide__main');
    const employersGuideSidebar = document.querySelector('.content-sidebar--navigation');

    if (employersGuideMain && employersGuideSidebar && window.innerWidth >= 1024) {
      const sidebarHeight = employersGuideSidebar.offsetHeight;
      const sidebarTop = employersGuideSidebar.getBoundingClientRect().top + window.scrollY;
      const contentTop = employersGuideMain.getBoundingClientRect().top + window.scrollY;
      const offset = contentTop - sidebarTop; // How much higher the sidebar starts
      const minHeight = sidebarHeight - offset; // Sidebar height minus the offset
      employersGuideMain.style.minHeight = minHeight + "px";
    } else if (employersGuideMain) {
      employersGuideMain.style.minHeight = ""; // reset on mobile
    }

    if (!sideMenu || !main) return;

    // Only update the min-height if viewport is at least 1024px wide
    if (window.innerWidth >= 1024) {
      if (sideMenu.hasAttribute('data-adjusttop')) {
        const mainContent = document.querySelector('.employersGuide');
        const mainSide = document.querySelector('.employersGuide__side');
        if (mainContent && mainSide) {
            let mainContentTop = mainContent.getBoundingClientRect().top + window.scrollY - 128;
            const collectiveAgreement = document.querySelector('.collective-digital');
            const sidebar = collectiveAgreement ? document.querySelector('.collective-digital--sidebar') : null;
            if (collectiveAgreement && sidebar) {
                const isChapterPage = !!document.querySelector('.collective-chapter-page');
                const normal = isChapterPage
                    ? document.querySelector('.subpagehero--employersGuide .content-header')
                    : document.querySelector('.employersGuide__hook > :first-child');

                function syncPosition() {
                        const { top } = normal.getBoundingClientRect();

                        const sidebarRect = sidebar.getBoundingClientRect();
                        const mainSideWidth = mainSide.offsetWidth;
                        const sidebarCenter = sidebarRect.left + (sidebarRect.width / 2);
                        const leftValue = `${sidebarCenter - (mainSideWidth / 2)}px`;

                        Object.assign(mainSide.style, {
                            position: 'fixed',
                            top: `${top}px`,
                            left: leftValue,
                            right: 'auto'
                        });
                }

                syncPosition();
                window.addEventListener('scroll', syncPosition);
                window.addEventListener('resize', syncPosition);

            } else {
                mainSide.style.top = mainContentTop + 'px';
            }

                const height = mainSide.offsetHeight;
                mainContent.style.minHeight = height + 64 + "px";
        }
      } else {
        const height = sideMenu.offsetHeight + 350; // add 350px offset
        main.style.minHeight = height + "px";
      }

    } else {
      main.style.minHeight = ""; // reset inline min-height for smaller viewports
    }

    // Add 'last' class to last li in sideMenu
    const listItems = sideMenu.querySelectorAll('li');
    if (listItems.length > 0) {
      listItems[listItems.length - 1].classList.add('last');
    }
  }

  function recalcSidebarLayout() {
    // Kör efter att layouten uppdaterats
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        updateMainHeight();
      });
    });
  }

  // Gör den tillgänglig för andra skript (t ex din TOC toggle)
  window.recalcSidebarLayout = recalcSidebarLayout;

  function syncCommonPageSidebar() {
    const contentHook = document.querySelector('.content--hook');
    const sidebarHook = document.querySelector('.content-sidebar--hook');

    if (!contentHook || !sidebarHook) return;

    // Only update on desktop viewports (1024px and above)
    if (window.innerWidth >= 1024) {
      const firstChild = contentHook.querySelector(':first-child');
      if (firstChild) {
        const styles = getComputedStyle(firstChild);
        const marginTop = parseFloat(styles.marginTop) || 0;
        const paddingTop = parseFloat(styles.paddingTop) || 0;

        // Remove negative margin from content--narrowFigure and apply content spacing
        const totalOffset = marginTop + paddingTop;
        sidebarHook.style.marginTop = '0';
        sidebarHook.style.paddingTop = `${totalOffset}px`;
      }
    } else {
      // Reset inline styles on mobile to use default SCSS
      sidebarHook.style.marginTop = '';
      sidebarHook.style.paddingTop = '';
    }
  }

  // Update min-height on initial load
  updateMainHeight();

  // Optional: Update min-height on window resize to handle dynamic viewport changes
  window.addEventListener("resize", updateMainHeight);

  // Sync CommonPage sidebar padding on initial load
  syncCommonPageSidebar();

  // Update CommonPage sidebar padding on window resize
  window.addEventListener("resize", syncCommonPageSidebar);

  // New: Add click event for .sideMenu-heading to toggle .sideMenu-list--expanded on its sibling .sideMenu-list
  // and toggle an active class on the heading itself.
  const headings = document.querySelectorAll('.sideMenu-heading');
  headings.forEach(heading => {
    heading.addEventListener('click', function () {
      // Find the sibling element with the class .sideMenu-list within the same parent.
      const siblingList = this.parentElement.querySelector('.sideMenu-list');
      if (siblingList) {
        siblingList.classList.toggle('sideMenu-list--expanded');
        // Toggle an active class on the heading based on the sibling list's state.
        if (siblingList.classList.contains('sideMenu-list--expanded')) {
          this.classList.add('sideMenu-heading--active');
        } else {
          this.classList.remove('sideMenu-heading--active');
        }
      }
    });
  });
})();
